export const StatusCodes = {
    // ✅ 2xx: 성공
    OK: 200, // 일반 성공
    CREATED: 201, // 새 리소스 생성 성공
    NO_CONTENT: 204, // 응답 본문 없음

    // ⚠️ 4xx: 클라이언트 오류
    BAD_REQUEST: 400, // 잘못된 요청
    UNAUTHORIZED: 401, // 인증 필요 (로그인 안됨)
    FORBIDDEN: 403, // 접근 권한 없음
    NOT_FOUND: 404, // 리소스 없음
    CONFLICT: 409, // 중복, 충돌
    TOO_MANY_REQUESTS: 429, // 요청 과다 (rate limit)

    // 💣 5xx: 서버 오류
    INTERNAL_SERVER_ERROR: 500, // 일반 서버 에러
    NOT_IMPLEMENTED: 501, // 아직 구현 안됨
    BAD_GATEWAY: 502, // 게이트웨이 오류
    SERVICE_UNAVAILABLE: 503, // 서비스 불가 (점검 중 등)
    GATEWAY_TIMEOUT: 504, // 게이트웨이 타임아웃
};
